"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectMode = void 0;
/**
 * 连接模式（默认 Websocket 模式）
 *
 * @enum {number}
 */
var ConnectMode;
(function (ConnectMode) {
    /**
     * Websocket 模式
     */
    ConnectMode["WEBSOCKET"] = "WEBSOCKET";
    /**
     * 大协同
     */
    ConnectMode["BIG_COLLAB"] = "BIG_COLLAB";
    /**
     * 强制 websocket
     */
    ConnectMode["WEBSOCKET_FORCED"] = "WEBSOCKET_FORCED";
})(ConnectMode || (ConnectMode = {}));
exports.ConnectMode = ConnectMode;
